const OT_GRAYS = {
  black: '#000',   /* (0,0,0) */
  white: '#fff',   /* (255,255,255) */
  grayLt: '#eef3f7',   /*  '#eee(238,238,238) */
  grayMidLt: '#ccc',   /* (204,204,204) */
  gray: '#888',   /* (136,136,136) */
  grayMidDk: '#666',   /* (102,102,102) */
  grayDk: '#3b454a',   /* '#222 (34,34,34) */
}

const OT_COLORS = {
  blue:  '#3395ff',   /* (0,140,255) */
  red: '#990000',   /* (153,0,0) */
  green: '#27cc6a',   /* (49,178,28) */
  yellow: '#fdbc34',   /* (245,166,35) */
  purple: '#7e61ec',
}

const OT_BGD_COLORS = {
  skyblue:  '#e0f2ff'   /* (224,242,255) */
}

// const getRandomHEXColor = () => {
//   return '#'+( (1<<24) * Math.random() |  0).toString(16);
// }

const convertHSLtoRGB = (hsl) => {
  if (hsl) {
    let h  = hsl.h % 360;
    let l = hsl.l/100;
    let s = hsl.s/100;

    let c = (1 - Math.abs(2 * l - 1))* s ;
    let x = c * (1 - Math.abs((h/60)%2-1));
    let m = l - c/2;
    let r;

    if(h>=0 && h<60) r=[c,x,0];
    else if(h>=60 && h<120) r=[x,c,0];
    else if(h>=120 && h<180) r=[0,c,x];
    else if(h>=180 && h<240) r=[0,c,x];
    else if(h>=240 && h<300) r=[x,0,c];
    else if(h>=300 && h<360) r=[c,0,x];

    return { r: Math.round((r[0]+m) * 255), g: Math.round((r[1]+m) * 255), b: Math.round((r[2]+m) * 255) };
  }
}

const convertRGBtoHEX = (rgb) => {
  if (rgb) {
    let { r, g, b } = rgb;
    return `#${( (1<<24) + (r << 16) + (g << 8) + b ).toString(16).slice(1)}`;
  }
}

const getRandomBrightColor = (format: 'HEX') => {
  let hsl = getRandomHSL();
  let rgb = convertHSLtoRGB(hsl);

    if (format === 'RGB')  return `(${rgb.r}, ${rgb.g}, ${rgb.b})`;
    else return convertRGBtoHEX(rgb);
}

const getRandomHSL = () => { // returns object for bright color
  return { h: Math.round(Math.random() * 360), s: 100, l: 50 };
}
export {
  OT_GRAYS,
  OT_COLORS,
  getRandomBrightColor
};



// WEBPACK FOOTER //
// ./src/utils/colorUtils.js